// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".oc-radio[data-v-a823db60]{display:flex;position:relative;align-items:center;cursor:pointer}.oc-radio input[type=radio][data-v-a823db60]{z-index:-1;position:absolute;top:0;left:0;opacity:0}.oc-radio__icon-wrapper[data-v-a823db60]{width:15px;height:15px;flex:none}.oc-radio__icon[data-v-a823db60]{color:#0071bc}", ""]);
// Exports
module.exports = exports;
